import SyColorpicker from "./sy-colorpicker";

export default SyColorpicker;
